import React from 'react';
import { action, makeObservable, observable, runInAction } from 'mobx';
import { getMenus, getOpers } from '@/api/menu';
import _, { cloneDeep } from 'lodash';
import { treeToList } from '../utils/index';
import global from './global';
import { pathToRegexp } from 'path-to-regexp';

class Menu {
    constructor() {
        makeObservable(this);
    }

    @observable
    opersMap = []; //权限集合--按钮
    @observable
    collapsed = false;
    @action
    setCollapsed = (flag) => {
        this.collapsed = flag;
    };
    @observable
    defaultSide = {};
    @observable
    menuState = {
        curRouteInfo: {},
        outSelectMenu: { id: 'home', name: '首页' },
        subSelectMenu: {},
        subMenuOpenKeys: []
    };
    @action
    setMenuState = (data) => {
        this.menuState = Object.assign({}, this.menuState, data);
    };
    getSelectMenusByRoutePath = (path) => {
        let data = cloneDeep(this.menus),
            routes = cloneDeep(this.routes),
            menuList = treeToList(data),
            leaf = null;

        //低代码
        if (path.includes('tenant/view/')) {
            let pageKey = path.substring(12);
            leaf = menuList.find((ele) => ele.page_key === pageKey);
        } else {
            //如果直接在菜单里找到了，就使用
            //如果找不到，就去动态路由里面去找
            let temLeaf = menuList.find((ele) => ele.resource_path === path);
            if (temLeaf && temLeaf.id) {
                leaf = temLeaf;
            } else {
                for (const item of routes) {
                    let menuPath = item.resource_path;
                    if (menuPath) {
                        const reg = pathToRegexp(menuPath);
                        if (reg.test(path)) {
                            leaf = menuList.find((ele) => ele.id === item.id);
                            if (!leaf || leaf?.resource_path) {
                                const match = function (menuPath, path) {
                                        try {
                                            const reg = pathToRegexp(menuPath);
                                            return reg.test(path);
                                        } catch (err) {
                                            console.log(err);
                                            return false;
                                        }
                                    },
                                    resourcePath = item.resource_path,
                                    resourcePathArr = resourcePath?.split('/');
                                let len = resourcePathArr?.length,
                                    f = false;
                                while (len) {
                                    for (let i = 0; i < menuList.length; i++) {
                                        const menuItem = menuList[i];
                                        if (menuItem && menuItem.resource_path) {
                                            const result = match(menuItem.resource_path, resourcePathArr.join('/'));
                                            if (result) {
                                                leaf = menuItem;
                                                f = true;
                                                break;
                                            }
                                        }
                                    }
                                    if (f) break;
                                    resourcePathArr.pop();
                                    len--;
                                }
                            }
                            break;
                        }
                    }
                }
            }
        }
        if (!leaf) {
            return [];
        }
        let res = [{ name: leaf.name, id: leaf.id }],
            temNode = leaf,
            flag = true;
        while (flag) {
            temNode = menuList.find((ele) => ele.id === temNode.parent_id);
            if (temNode) {
                res.unshift({
                    name: temNode.name,
                    id: temNode.id
                });
            } else {
                flag = false;
            }
        }
        return res;
    };

    @observable
    menus = [];
    @action
    setMenus = (result) => {
        this.menus = result;
    };

    //侧边栏手柄
    @observable
    handleVisible = false;

    @action
    setHandleVisible = (v) => {
        this.handleVisible = v;
    };
    //需要注册的路由
    @observable
    routes = [];

    @action
    setRoutes = (v) => {
        this.routes = v;
    };

    //是否有菜单
    isHaveMenu = (data) => {
        if (!data) {
            return -1;
        }
        return data.findIndex((ele) => {
            return ele.resource_type === 1 || ele.resource_type === 2;
        });
    };
    //找出所有叶子节点----用来注册路由
    getAllLeaf = (data) => {
        let result = [],
            getLeaf = (data) => {
                data.forEach((item) => {
                    //存在子集 并且子集内存在菜单类型的资源
                    //避免该资源是叶子菜单，但是children内，存在接口类型的资源，导致else if 的逻辑 进不去，路由注册不上
                    if (item.children && item.children.length && this.isHaveMenu(item.children) !== -1) {
                        getLeaf(item.children);
                    } else if (item.resource_type !== 4) {
                        result.push(item);
                    }
                });
            };
        getLeaf(data);
        return result;
    };

    //生成菜单--过滤出展示菜单
    getOutMenus = (menu) => {
        let data = _.cloneDeep(menu);
        return data.filter((ele) => {
            if (ele.resource_show && ele.children && ele.children.length) {
                ele.children = this.getOutMenus(ele.children);
            }
            return (ele.resource_type === 1 || ele.resource_type === 2) && ele.resource_show;
        });
    };
    //处理菜单的选中状态
    handleMenuState = () => {
        //因为此时菜单已经请求完毕，并且菜单仅有三层，
        //路由注册是完全平铺的
        if (location.pathname === `/${this.defaultSide.side_url}` || location.pathname === `/${this.defaultSide.side_url}/manage/statistics`) {
            this.setMenuState({
                outSelectMenu: { id: 'home', name: '首页' },
                subSelectMenu: {},
                subMenuOpenKeys: []
            });
            return false;
        }
        let routePath = location.pathname.split('/').splice(2).join('/'), //获取路由参数--前两个是所在端
            res = this.getSelectMenusByRoutePath(routePath); //[1级菜单,2级菜单,3级菜单]

        //路由存在
        if (res.length > 0) {
            let outSelectMenu = this.menus.find((ele) => ele.id === res[0].id),
                ids = res.map((ele) => ele.id);
            this.setMenuState({
                curRouteInfo: res[2],
                outSelectMenu: outSelectMenu,
                subSelectMenu: res[2],
                subMenuOpenKeys: ids
            });
        }
    };
    getOpers = async () => {
        let res = await getOpers();
        if (res && res.data) {
            runInAction(() => {
                let keys = res.data.map((ele) => ele.resource_key) || [];
                global.setGlobalState({ opersMap: keys });
            });
        }
    };
    fetchMenuList = async (defaultSide) => {
        runInAction(() => {
            this.defaultSide = defaultSide;
        });
        let sideId = defaultSide.id;
        const res = await getMenus(sideId),
            data = res ? res.data || [] : [];

        let menu = this.getOutMenus(data);

        this.setMenus(menu);
        let list = this.getAllLeaf(data);

        list = list.map((ele) => {
            return {
                ...ele,
                resource_path: `${ele.resource_path}`,
                element: <></>,
                resourcePageName: 'NestedRoute',
                resource_name: 'NestedRoute'
            };
        });
        list.push({
            resource_path: 'tenant/view/:id',
            element: <></>,
            resourcePageName: '低代码渲染',
            resource_name: '低代码渲染'
        });
        list.push({
            resource_path: 'manage/statistics',
            element: <></>,
            resourcePageName: '驾驶舱',
            resource_name: '驾驶舱'
        });
        list.push({
            resource_path: 'manage/test',
            element: <></>,
            resourcePageName: '测试页面',
            resource_name: '测试页面'
        });
        // list.push({ resource_path: 'manage/exam-paper-manage', element: <></>, resourcePageName: '低代码渲染', resource_name: '低代码渲染' });
        // list.push({ resource_path: 'manage/improve-test-paper/:id', element: <></>, resourcePageName: '低代码渲染', resource_name: '低代码渲染' });
        list.push({ resource_path: '*', element: <></>, resourcePageName: 'error', resource_name: '未匹配到路由' });
        // list.push({ resource_path: 'manage/overall-portrait', element: <></>, resourcePageName: '整体学员画像', resource_name: '整体学员画像' });

        // if (platform === 'admin') {
        //     this.setAdminRoutes(list);
        // } else {
        //     this.setRoutes(list);
        // }
        this.setRoutes(list);
        this.handleMenuState();
    };
}

export default new Menu();
